import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const DeleteConfirmation = ({ showModal, hideModal, confirmModal, id, type, message, proceedDelete, requireConfirmation }) => {
    const [agreed, setAgreed] = useState(false);

    // Reset checkbox every time the modal opens
    useEffect(() => {
        if (showModal) setAgreed(false);
    }, [showModal]);

    const deleteEnabled = proceedDelete && (!requireConfirmation || agreed);

    return (
        <Modal show={showModal} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warn">{message}</div>
                {requireConfirmation && (
                    <Form.Check
                        type="checkbox"
                        id="delete-agree-checkbox"
                        label="I agree"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                        style={{ marginTop: '12px', fontWeight: 500 }}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                {!proceedDelete ?
                    <Button variant="secondary" onClick={hideModal}>
                        OK
                    </Button>
                    :
                    <div>
                        <Button className='cancel_button' variant="secondary" onClick={hideModal}>
                            Cancel
                        </Button>
                        <span style={{ cursor: !deleteEnabled ? 'not-allowed' : 'default', display: 'inline-block' }}>
                            <Button
                                disabled={!deleteEnabled}
                                variant="danger"
                                onClick={() => confirmModal(type, id)}
                                style={{ pointerEvents: !deleteEnabled ? 'none' : 'auto' }}
                            >
                                Delete
                            </Button>
                        </span>
                    </div>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmation;